"use strict";
/**
 * @file Created on Tue Mar 17 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ForecastSimulationUpdateResultDTO_1 = require("../model/ForecastSimulationUpdateResultDTO");

var ForecastSimulationConflictDTOConverter_1 = require("./ForecastSimulationConflictDTOConverter");

var ForecastSimulationUpdateResultDTOConverter_1 = require("./ForecastSimulationUpdateResultDTOConverter");

var TreeInfoDTOConverter_1 = require("./TreeInfoDTOConverter");
/**
 * @author Tomas Leity
 */


var ForecastSimulationUpdateResultDTOConverterImpl =
/*#__PURE__*/
function (_ForecastSimulationUp) {
  _inherits(ForecastSimulationUpdateResultDTOConverterImpl, _ForecastSimulationUp);

  function ForecastSimulationUpdateResultDTOConverterImpl(treeInfoDTOConverter, simulationConflictDTOConverter) {
    var _this;

    _classCallCheck(this, ForecastSimulationUpdateResultDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationUpdateResultDTOConverterImpl).call(this));
    _this.treeInfoDTOConverter = treeInfoDTOConverter;
    _this.simulationConflictDTOConverter = simulationConflictDTOConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ForecastSimulationUpdateResultDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ForecastSimulationUpdateResultDTO_1.ForecastSimulationUpdateResultDTO(conversions.asObjectList(source, 'nodes', function (doc) {
        return _this2.treeInfoDTOConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'conflicts', function (doc) {
        return _this2.simulationConflictDTOConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        nodes: conversions.asObjectArray(source, 'nodes', function (obj) {
          return _this3.treeInfoDTOConverter.toDocument(obj, conversions);
        }),
        conflicts: conversions.asObjectOpt(source, 'conflicts', function (dto) {
          return _this3.simulationConflictDTOConverter.toDocument(dto, conversions);
        })
      };
    }
  }]);

  return ForecastSimulationUpdateResultDTOConverterImpl;
}(ForecastSimulationUpdateResultDTOConverter_1.ForecastSimulationUpdateResultDTOConverter);

ForecastSimulationUpdateResultDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [TreeInfoDTOConverter_1.TreeInfoDTOConverter, ForecastSimulationConflictDTOConverter_1.ForecastSimulationConflictDTOConverter])], ForecastSimulationUpdateResultDTOConverterImpl);
exports.ForecastSimulationUpdateResultDTOConverterImpl = ForecastSimulationUpdateResultDTOConverterImpl;